module.exports = __webpack_public_path__ + "static/media/logon-logo-dark.b7fded68.png";